/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Voice_Save_BtnInputs */

const vi_station_voice_save_btn = /** @type {(inputs: Station_Voice_Save_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu cấu hình`)
};

/**

* @param {Station_Voice_Save_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_voice_save_btn = /** @type {((inputs?: Station_Voice_Save_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Voice_Save_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_voice_save_btn(inputs)
});